// Lấy thông tin chuyển khoản
export const FETCH_TRANSFER_INFO_REQUEST = "FETCH_TRANSFER_INFO_REQUEST";
export const FETCH_TRANSFER_INFO_SUCCESS = "FETCH_TRANSFER_INFO_SUCCESS";
export const FETCH_TRANSFER_INFO_FAILURE = "FETCH_TRANSFER_INFO_FAILURE";
